export const POST_GROUP = 'POST_GROUP';
export const LIST_GROUP = 'LIST_GROUP';
